module.exports = "/_next/static/images/Igor_Papo-17b76e32062c0267b8833642b59cc01a.webp";